import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import DeleteIcon from '@material-ui/icons/Delete';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { IconButton, Tooltip } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useRoute } from 'src/app/infra/routes';
import { deleteProcuracoesByCod, getProcuracoes } from 'src/app/services/votacao';
import { BtnLoading, Loading, Msgbox } from 'src/app/shared/utils';
import { Procuracoes } from 'src/app/types/votacao';
import { useWrapper } from 'src/utils/axios';
import { Title, Wrapper } from '../login';

const Centered = styled.span`
  display: flex;
  justify-content: center;
  width: 100%;
  font-weight: bold;
  margin-bottom: 12px;
`;

export const Consult = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;

  h5,
  .MuiFormControl-root {
    width: 100%;
    margin-top: 0px;
  }
`;

const StyledTableCell = withStyles(() => ({
    head: {
      backgroundColor: '#e5e5e5',
      color: '#000',
      fontWeight: 'bold',
    //   border: '1px solid #c6c6c6'
    },
    body: {
      fontSize: 14,
    //   border: '1px solid #c6c6c6',

    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      },
    },
  }))(TableRow);

interface Props {
  open: boolean;
  handleClose: (done: boolean) => void;
  codigoVotacao: Number | undefined;
}

export default ({ open, handleClose, codigoVotacao }: Props) => {
  const resProcuracao = useWrapper<Procuracoes[]>();
  const deleteProcuracaos = useWrapper();

  const { params: { condominio } } = useRoute();
  const [openExclude, setOpenExclude] = useState(false);
  const [codigoProcuracao, setCodigoProcuracao] = useState((Number));

  const refresh = () => {
    resProcuracao.exec(
      getProcuracoes(Number(codigoVotacao))
    );

    return () => resProcuracao.cancel();
  }

  useEffect(() => {
    if(open) {
      refresh()
    }
}, [open])

  const deleteProcuracao = () => {
    deleteProcuracaos.exec(
      deleteProcuracoesByCod(Number(codigoVotacao), codigoProcuracao),
      () => {
        setOpenExclude(false);
        refresh();
       }
    );
  }

  return (
    <Dialog
      open={open}
      onClose={() => handleClose(false)}
      maxWidth="md"
      onLoad={() => resProcuracao.loading}
    >
        <Row>
          <Title variant="h5" color="primary">Consultar Procurações</Title>
          <IconButton onClick={() => handleClose(false)}>
            <Close />
          </IconButton>
        </Row>
        <DialogContent>
          <Consult>
            <Centered>
                Confira a lista e o status das procurações enviadas. Se
                desejar excluir, selecione a procuração e confirme.
            </Centered>
            <Centered style={{color: 'red'}}>
                Lista de Procurações do Condominio {condominio}.
            </Centered>
            {
              resProcuracao.payload && resProcuracao.payload.length ?
            <TableContainer component={Paper}>
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                      <StyledTableCell>ID</StyledTableCell>
                      <StyledTableCell align="center">Representantes</StyledTableCell>
                      <StyledTableCell align="center">Unid. Representadas</StyledTableCell>
                      <StyledTableCell align="center">Status</StyledTableCell>
                      <StyledTableCell align="center"></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                  resProcuracao.payload.map((row) => (
                    <StyledTableRow key={row.codigo}>
                    <StyledTableCell component="th" scope="row">
                        {row.codigo}
                    </StyledTableCell>
                    <StyledTableCell align="center">{row.nomeProcuracao}</StyledTableCell>
                    <StyledTableCell align="center">{row.unidade}</StyledTableCell>
                    <StyledTableCell align="center">{row.descricaoSituacao}</StyledTableCell>
                    <StyledTableCell align="center">
                      <Button
                        onClick={() => {
                          setCodigoProcuracao(Number(row.codigo));
                          setOpenExclude(true);
                          }}
                      >
                        <Tooltip title="Clique aqui para Excluir">
                          <IconButton color="primary" aria-label="delete">
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </Button>
                    </StyledTableCell>
                    </StyledTableRow>
                  ))
                  }
                </TableBody>
              </Table>
            </TableContainer>
            :
            <DialogTitle>
              <Title variant="h5" color="primary" style={{padding: '16px'}}>Nenhuma Procuração Encontrada!</Title>
            </DialogTitle>
            }
            <Centered style={{marginTop: '12px'}}>
              <Dialog
                open={openExclude}
                onClose={() => setOpenExclude(false)}
                maxWidth="xs"
              >
                <DialogTitle>
                  <Title variant="h5" color="primary" >Deseja Mesmo Excluir a Procuração?</Title>
                </DialogTitle>
                <DialogContent>
                  <Wrapper>
                    <DialogActions style={{display: 'flex', justifyContent: 'center'}}>
                      <BtnLoading
                        loading={deleteProcuracaos.loading}
                        onClick={() => deleteProcuracao()}
                      >
                        Sim
                      </BtnLoading>
                      <BtnLoading
                        loading={false}
                        onClick={() => setOpenExclude(false)}
                      >
                        Não
                      </BtnLoading>
                    </DialogActions>
                    <Centered>
                    </Centered>
                  </Wrapper>
                </DialogContent>
                <Msgbox error={deleteProcuracaos.error} onClose={() => {deleteProcuracaos.reset(); setOpenExclude(false)}} />
              </Dialog>
            </Centered>
          </Consult>
        </DialogContent>
        <Loading open={resProcuracao.loading} hasBackdrop />
        <Msgbox error={resProcuracao.error} onClose={() => resProcuracao.reset()} />
    </Dialog>
  );
}